import { handleAxiosErrors } from '../../_utils';
import {
    axiosCreateCreditCard,
    axiosDeleteCreditCard,
    axiosRequestCreditCards,
    axiosRequestDefaultCreditCardID,
} from '../creditCardActions';
import { convertUserDetailedInformationToAReadableFormat } from '../../selectors/converterSelector';
import {
    toggleLoading,
    setUserInfo,
    submitAccountHolderInformation,
} from '../userActions';
import { requestAddresses } from './address';

/**
 * Request Credit Cards
 */
export const requestCreditCards = () => {
    return (dispatch) => {
        dispatch(toggleLoading('creditCardList', true));
        return axiosRequestCreditCards()
            .then((response) => {
                const userInfo = convertUserDetailedInformationToAReadableFormat(
                    response.data.data.readOneMember
                );
                dispatch(setUserInfo(userInfo));

                dispatch(toggleLoading('creditCardList', false));
            })
            .catch((error) => {
                handleAxiosErrors(error);
                dispatch(toggleLoading('creditCardList', false));
            });
    };
};
/**
 * Request default credit card ID
 * This is called after setting default credit card
 */
export const requestDefaultCreditCardID = () => {
    return (dispatch) => {
        dispatch(toggleLoading('creditCardList', true));
        return axiosRequestDefaultCreditCardID()
            .then((response) => {
                const userInfo = convertUserDetailedInformationToAReadableFormat(
                    response.data.data.readOneMember
                );
                dispatch(setUserInfo(userInfo));

                dispatch(toggleLoading('creditCardList', false));
            })
            .catch((error) => {
                handleAxiosErrors(error);
                dispatch(toggleLoading('creditCardList', false));
            });
    };
};

/**
 * Create credit card based on the given data
 * And render list when it succeeds
 *
 * @param formData
 * @param callback
 */
export const createCreditCard = (formData, callback) => {
    return (dispatch) => {
        const successCallback =
            typeof callback.success != 'undefined' ? callback.success : null;
        const errorCallback =
            typeof callback.error != 'undefined' ? callback.error : null;
        const alwaysCallback =
            typeof callback.always != 'undefined' ? callback.always : null;

        return axiosCreateCreditCard(formData)
            .then((response) => {
                dispatch(requestCreditCards());
                dispatch(requestAddresses());

                // Callbacks
                if (successCallback) successCallback(response);
                if (alwaysCallback) alwaysCallback(response);
            })
            .catch((response) => {
                handleAxiosErrors(response);

                // Callbacks
                if (errorCallback) errorCallback(response);
                if (alwaysCallback) alwaysCallback(response);
            });
    };
};

/**
 * Set default credit card
 * It uses submitAccountHolderInformation() as main endpoint
 *
 * @param id
 * @param callback
 */
export const makeDefaultCreditCard = (id, callback) => {
    return (dispatch) => {
        const newCallback = {
            success: (response) => {
                if (typeof callback.success != 'undefined') {
                    callback.success(response);
                }
                dispatch(requestDefaultCreditCardID());
            },
            error: (response) => {
                if (typeof callback.error != 'undefined') {
                    callback.error(response);
                }
            },
            always: (response) => {
                if (typeof callback.always != 'undefined') {
                    callback.always(response);
                }
            },
        };

        return dispatch(
            submitAccountHolderInformation(
                { SavedCreditCardID: Number(id) },
                newCallback
            )
        );
    };
};

/**
 * Delete the selected credit card
 *
 * @param id
 * @param callback
 */
export const deleteCreditCard = (id, callback) => {
    return (dispatch) => {
        const successCallback =
            typeof callback.success != 'undefined' ? callback.success : null;
        const errorCallback =
            typeof callback.error != 'undefined' ? callback.error : null;
        const alwaysCallback =
            typeof callback.always != 'undefined' ? callback.always : null;

        return axiosDeleteCreditCard(id)
            .then((response) => {
                dispatch(requestCreditCards());

                // Callbacks
                if (successCallback) successCallback(response);
                if (alwaysCallback) alwaysCallback(response);
            })
            .catch((response) => {
                handleAxiosErrors(response);

                // Callbacks
                if (errorCallback) errorCallback(response);
                if (alwaysCallback) alwaysCallback(response);
            });
    };
};
